export default {
  computed: {
  select_all_bp: {
    get() {
      return this.selected.bp;
    },
    set(value) {
      this.selected.bp = value;
      if (this.selo) {
        this.order_food.forEach(function (item) {
          item.bp = value;
        });
        return;
      }
      const selected = this.selected;
      this.order_food.forEach(function (item) {
        item.bp = value;
        if (item.bpO) {
          if (value) {
            item.bpO = false;
            selected.bpO = false;
          }
        }
      });
    },
  },
  select_all_bpO: {
    get() {
      return this.selected.bpO;
    },
    set(value) {
      this.selected.bpO = value;
      if (this.selo) {
        this.order_food.forEach(function (item) {
          item.bpO = value;
        });
        return;
      }
      const selected = this.selected;
      this.order_food.forEach(function (item) {
        item.bpO = value;
        if (item.bp) {
          if (value) {
            item.bp = false;
            selected.bp = false;
          }
        }
      });
    },
  },
  select_all_bpP: {
    get() {
      return this.selected.bpP;
    },
    set(value) {
      this.selected.bpP = value;
      if (this.selo) {
        this.order_food.forEach(function (item) {
          item.bpP = value;
        });
        return;
      }
      const selected = this.selected;
      this.order_food.forEach(function (item) {
        item.bpP = value;
        if (value) {
          if (item.bp && item.bpO) {
            item.bp = false;
            selected.bp = false;
          }
        }
      });
    },
  },
  select_all_pp: {
    get() {
      return this.selected.pp;
    },
    set(value) {
      this.selected.pp = value;
      this.order_food.forEach(function (item) {
        if (item.balance < 60) {
          item.pp = false;
        } else {
          item.pp = value;
        }
      });
    },
  },
  select_all_ppO: {
    get() {
      return this.selected.ppO;
    },
    set(value) {
      this.selected.ppO = value;
      this.order_food.forEach(function (item) {
        if (item.balance < 60) {
          item.ppO = false;
        } else {
          item.ppO = value;
        }
      });
    },
  },
  select_all_ppP: {
    get() {
      return this.selected.ppP;
    },
    set(value) {
      this.selected.ppP = value;
      this.order_food.forEach(function (item) {
        if (item.balance < 60) {
          item.ppP = false;
        } else {
          item.ppP = value;
        }
      });
    },
  },
  select_all_lg_food: {
    get() {
      return this.selected.lg_food;
    },
    set(value) {
      this.selected.lg = value;
      this.order_food.forEach(function (item) {
        if (!!Number(item.LGOTA) === false) {
          item.lg = false;
        } else {
          item.lg = value;
        }
      });
    },
  },
  select_all_lgZ1_food: {
    get() {
      return this.selected.lgZ1;
    },
    set(value) {
      this.selected.lgZ1 = value;
      if (value) {
        this.select_all_lg_zav = false;
        if (this.selected.lgO1 && this.selected.lgP1) {
          this.select_all_lgP1_food = false;
          this.selected.lgP1 = false;
        }
        this.order_food.forEach(item => {
          if (this.selected.lgO1) {
            if (!!Number(item.LGOTA) === false || item.type_lgota != 'овз') {
              item.lgZ1 = false;
            } else {
              item.lgZ1 = value;
              item.lgZ = false;
            }
          } else {
            if (!!Number(item.LGOTA) === false) {
              item.lgZ1 = false;
            } else {
              item.lgZ1 = value;
              item.lgZ = false;
            }
          }
        });
      } else {
        this.order_food.forEach(function (item) {
          if (!!Number(item.LGOTA) === false) {
            item.lgZ1 = false;
          } else {
            item.lgZ1 = value;
          }
        });
      }
    },
  },
  select_all_lgO1_food: {
    get() {
      return this.selected.lgO1;
    },
    set(value) {
      this.selected.lgO1 = value;
      if (value) {
        this.select_all_lg_ob = false;
        if (this.selected.lgZ1 && this.selected.lgP1) {
          this.select_all_lgP1_food = false;
          this.selected.lgP1 = false;
        }
        this.order_food.forEach(item => {
          if (this.selected.lgZ1) {
            if (!!Number(item.LGOTA) === false || item.type_lgota != 'овз') {
              item.lgO1 = false;
            } else {
              item.lgO1 = value;
              item.lgO = false;
            }
          } else {
            if (!!Number(item.LGOTA) === false) {
              item.lgO1 = false;
            } else {
              item.lgO1 = value;
              item.lgO = false;
            }
          }
        });
      } else {
        this.order_food.forEach(function (item) {
          if (!!Number(item.LGOTA) === false) {
            item.lgO1 = false;
          } else {
            item.lgO1 = value;
          }
        });
      }
    },
  },
  select_all_lgP1_food: {
    get() {
      return this.selected.lgP1;
    },
    set(value) {
      console.log(1);
      this.selected.lgP1 = value;

      if (value) {
        if (this.selected.lgZ1 && this.selected.lgO1) {
          this.select_all_lgZ1_food = false;
          this.selected.lgZ1 = false;
        }
        this.select_all_lg_ob = false;
        this.order_food.forEach(function (item) {
          if (
            !!Number(item.LGOTA) === false ||
            (item.type_lgota !== 'моб' && item.type_lgota !== 'овз')
          ) {
            item.lgP1 = false;
          } else {
            item.lgP1 = value;
            item.lgO = false;
          }
        });
      } else {
        this.order_food.forEach(function (item) {
          if (
            !!Number(item.LGOTA) === false ||
            (item.type_lgota !== 'моб' && item.type_lgota !== 'овз')
          ) {
            item.lgP1 = false;
          } else {
            item.lgP1 = value;
          }
        });
      }
    },
  },
  select_all_lg_zav: {
    get() {
      return this.selected.lgZ;
    },
    set(value) {
      this.selected.lgZ = value;
      if (value) {
        this.select_all_lgZ1_food = false;
        this.select_all_lg_ob = false;
        this.order_food.forEach(function (item) {
          if (
            !!Number(item.LGOTA) === false ||
            (!!Number(item.LGOTA) == true && Number(item.balance) < 17)
          ) {
            item.lgZ = false;
          } else {
            item.lgZ = value;
            item.lgZ1 = false;
          }
        });
      } else {
        this.order_food.forEach(function (item) {
          if (
            !!Number(item.LGOTA) === false ||
            (!!Number(item.LGOTA) == true && Number(item.balance) < 17)
          ) {
            item.lgZ = false;
          } else {
            item.lgZ = value;
          }
        });
      }
    },
  },
  select_all_lg_ob: {
    get() {
      return this.selected.lgO;
    },
    set(value) {
      this.selected.lgO = value;
      if (value) {
        this.select_all_lg_zav = false;
        this.select_all_lgO1_food = false;
        this.order_food.forEach(function (item) {
          if (
            !!Number(item.LGOTA) === false ||
            (!!Number(item.LGOTA) == true && Number(item.balance) < 17)
          ) {
            item.lgO = false;
          } else {
            item.lgO = value;
            item.lgO1 = false;
          }
        });
      } else {
        this.order_food.forEach(function (item) {
          if (
            !!Number(item.LGOTA) === false ||
            (!!Number(item.LGOTA) == true && Number(item.balance) < 17)
          ) {
            item.lgO = false;
          } else {
            item.lgO = value;
          }
        });
      }
    },
  },
  select_all_lg_gpd: {
    get() {
      return this.selected.gpd;
    },
    set(value) {
      if (value) {
        this.select_all_lg_gpdP = false;
        this.select_all_lg_gpdPD = false;
      }

      this.selected.gpd = value;
      this.order_food.forEach(function (item) {
        if (
          (Number(item.balance || 0) < 40 &&
            item.city.toLowerCase() == 'балаково') ||
          (Number(item.balance || 0) < 60 &&
            item.city.toLowerCase() == 'энгельс')
        ) {
          item.gpd = false;
        } else {
          item.gpd = value;
        }
      });
    },
  },
  select_all_lg_gpdP: {
    get() {
      return this.selected.gpdP;
    },
    set(value) {
      this.selected.gpdP = value;
      if (value) {
        this.select_all_lg_gpd = false;
        this.select_all_lg_gpdPD = false;
      }
      this.order_food.forEach(function (item) {
        if (Number(item.LGOTA || 0) != 1) {
          item.gpdP = false;
        } else {
          item.gpdP = value;
        }
      });
    },
  },
  select_all_lg_gpdPD: {
    get() {
      return this.selected.gpdPD;
    },
    set(value) {
      this.selected.gpdPD = value;
      if (value) {
        this.select_all_lg_gpdP = false;
        this.select_all_lg_gpd = false;
      }
      this.order_food.forEach(function (item) {
        if (
          Number(item.LGOTA || 0) != 1 ||
          (Number(item.balance || 0) < 40 &&
            item.city.toLowerCase() == 'балаково') ||
          (Number(item.balance || 0) < 60 &&
            item.city.toLowerCase() == 'энгельс')
        ) {
          item.gpdPD = false;
        } else {
          item.gpdPD = value;
        }
      });
    },
  },
  },
};